<div class="tabbable__body rounded-top-right no-margin">
  <h3>Här kan du administrera estimat för målgrupper</h3>

  @if (show.estimatesHaveChanged) {
    <import-warning></import-warning>
  }

  <form #shareOfTotalForm="ngForm" (ngSubmit)="updateShareOfTotal()">
  <label for="share">
    Andel av totallagret som ska vara tillgängligt för målgruppsbokningar
  </label>
  <div class="save-total-lager-container" >
    <div class="lager-input input__container flex__container align-items--end">
        <input
          name="share"
          [(ngModel)]="shareOfTotal"
          wooPercentFormatter
          [wooMinValidator]="0"
          [wooMaxValidator]="1"
        />
    </div>
    <div class="lager-button">
      <button
        class="button primary"
        type="submit"
        [disabled]="!shareOfTotalForm.valid"
      >
        Spara
      </button>
    </div>
  </div>
      
      <div class="divider margin-top-bottom--2x"></div>
      <div class="container">
        <div class="left-item">
          @if (show.isEditingWithdrawalLimit) {
            <button
            class="button primary"
            (click)="saveTargetGroups()"
            [disabled]="targetGroupsForm.invalid"
            >
            Spara
          </button>
          <button class="link" (click)="cancelEditingWithdrawalLimits()">
            Avbryt redigering
          </button>
        } @else {
          <button
            class="button primary"
            (click)="setEditingWithdrawalLimits(true)"
            >
            Redigera maxuttag
          </button>
        }
      </div>
      <div class="right-item">
        <div class="dropdown filter-dropdown">
          <woo-dropdown
            [items]="genders"
            [(ngModel)]="selectedGender"
            name="selectedGender"
            inputId="select-gender"
            labelText="Filtrera på Kön"
            notFoundText="Inga val hittades."
            [clearable]="true"
          ></woo-dropdown>
        </div>
        
        @if (productFormats?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
            [items]="productFormats"
            [(ngModel)]="selectedProductFormat"
            name="selectedProductFormat"
            inputId="select-product-format"
            labelText="Filtrera på Placering"
            [labelTransform]="translateProductFormat"
            notFoundText="Inga Placeringar hittades."
            [clearable]="true"
            ></woo-dropdown>
          </div>
        }
        
        @if (publishers?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
            [items]="publishers"
            [(ngModel)]="selectedPublisher"
            name="selectedPublisher"
            inputId="select-publisher"
            labelText="Filtrera på Publicist"
              notFoundText="Inga publicister hittades."
              [clearable]="true"
              ></woo-dropdown>
            </div>
          }
        </div>
      </div>
    </form>

  <div class="sticky-header">
      <h3>Tillgängliga målgrupper</h3>
  </div>

  <table
    class="table table-woo table--info table--hover width--100"
    ngForm
    #targetGroupsForm="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th [colSpan]="staticFields"></th>
        <th class="text-center" colspan="3">Maxuttag</th>
        <th></th>
      </tr>
      <tr>
        @for (header of tableHeaders; track header) {
          <th class="text--thin capitalize--first-letter">
            {{ header }}
          </th>
        }
        <th></th>
      </tr>
    </thead>

    @if (!show.loading) {
      <tbody>
        @for (row of targetGroupRows; track $index; let index = $index) {
          <tr [hidden]="!rowVisible(row)">
            <td class="text--thin vertical-align--middle">
              <span>{{ getGenderName(row.genderId) }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ getAgeName(row.ageId) }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ row.tag }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ getPublisherName(row.publisherId) }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ getProductFormatName(row.productFormatId) }}</span>
            </td>
            <td>
              @if (!show.isEditingWithdrawalLimit) {
                <span>{{ row.withdrawalLimitsPreroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  @if (row.ageId) {
                    <input
                      name="row-{{ index }}-withdrawalLimitsPreroll"
                      [(ngModel)]="
                        estimates.withdrawal_limits[row.productFormatId][row.genderId]
                          .ages[row.ageId].withdrawal_limits['preroll']
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes[row.productFormatId].preroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes[row.productFormatId].preroll
                      "
                    />
                  } @else {
                    <input
                      name="row-{{ index }}-withdrawalLimitsPreroll"
                      [(ngModel)]="
                        estimates.withdrawal_limits[row.productFormatId][row.genderId]
                          .withdrawal_limits['preroll']
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes[row.productFormatId].preroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes[row.productFormatId].preroll
                      "
                    />
                  }
                </div>
              }
            </td>
            <td>
              @if (!show.isEditingWithdrawalLimit) {
                <span>{{ row.withdrawalLimitsMidroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  @if (row.ageId) {
                    <input
                      name="row-{{ index }}-withdrawalLimitsMidroll"
                      [(ngModel)]="
                        estimates.withdrawal_limits[row.productFormatId][row.genderId]
                          .ages[row.ageId].withdrawal_limits['midroll']
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes[row.productFormatId].midroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes[row.productFormatId].midroll
                      "
                    />
                  } @else {
                    <input
                      name="row-{{ index }}-withdrawalLimitsMidroll"
                      [(ngModel)]="
                        estimates.withdrawal_limits[row.productFormatId][row.genderId]
                          .withdrawal_limits['midroll']
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes[row.productFormatId].midroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes[row.productFormatId].midroll
                      "
                    />
                  }
                </div>
              }
            </td>
            <td>
              @if (!show.isEditingWithdrawalLimit) {
                <span>{{ row.withdrawalLimitsPostroll | percent: '1.0-3' }}</span>
              } @else {
                <div class="input__container">
                  @if (row.ageId) {
                    <input
                      name="row-{{ index }}-withdrawalLimitsPostroll"
                      [(ngModel)]="
                        estimates.withdrawal_limits[row.productFormatId][row.genderId]
                          .ages[row.ageId].withdrawal_limits['postroll']
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes[row.productFormatId].postroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes[row.productFormatId].postroll
                      "
                    />
                  } @else {
                    <input
                      name="row-{{ index }}-withdrawalLimitsPostroll"
                      [(ngModel)]="
                        estimates.withdrawal_limits[row.productFormatId][row.genderId]
                          .withdrawal_limits['postroll']
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes[row.productFormatId].postroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes[row.productFormatId].postroll
                      "
                    />
                  }
                </div>
              }
            </td>
            <td class="text-center" (click)="setSelected(row)" style="cursor: pointer;">
              <span class="chevron" [ngClass]="openTab(row) ? 'bottom' : ''"></span>
            </td>
          </tr>
          @if(openTab(row)) {
            <tr >
              <th colspan="9" class="normal-text">
                <h3 class="text--semi-strong vertical-align--middle">Estimatfördelning</h3>
                <div class="two-button-container">
                  <div>
                    <table class="full-width">
                      <thead>
                        <tr>
                          @for (header of tableHeadersWeeklyShares; track header) {
                            <th
                              class="text-left text--white text--thin capitalize--first-letter padding--1x"
                              colspan="1"
                            >
                              {{ header }}
                            </th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        @for (week_shares of row.weekly_shares; let innerIndex = $index; track week_shares.week) {
                          <tr class="normal-text">
                            <td class="text-left text--semi-strong" style="width:120px;">
                              <span>{{ week_shares.week }}</span>
                            </td>
                            <td class="input__container override-table-input min-input" style="width:120px;">
                              @if (!isEditingWeekShares(row)) {
                                <span>{{ week_shares.sharesPreroll | percent: '1.0-3' }}</span>
                              } @else {
                                @if (row.ageId) {
                                  <input
                                  
                                    name="row-{{ index }}-shares-{{ innerIndex }}-sharesPreroll-{{ row.ageId }}"
                                    [(ngModel)]="
                                      estimates.shares[row.productFormatId][week_shares.week][row.genderId]
                                        .ages[row.ageId].shares['preroll']
                                    "
                                    wooPercentFormatter
                                    [wooMinValidator]="0"
                                    [wooMaxValidator]="1"
                                    [required]="
                                      includedProductFormatSlotTypes[row.productFormatId].preroll
                                    "
                                    [disabled]="
                                      !includedProductFormatSlotTypes[row.productFormatId].preroll
                                    "
                                  />
                                } @else {
                                  <input
                                    name="row-{{ index }}-shares-{{ innerIndex }}-sharesPreroll"
                                    [(ngModel)]="
                                      estimates.shares[row.productFormatId][week_shares.week][row.genderId]
                                        .shares['preroll']
                                    "
                                    wooPercentFormatter
                                    [wooMinValidator]="0"
                                    [wooMaxValidator]="1"
                                    [required]="
                                      includedProductFormatSlotTypes[row.productFormatId].preroll
                                    "
                                    [disabled]="
                                      !includedProductFormatSlotTypes[row.productFormatId].preroll
                                    "
                                  />
                                }
                              }
                            </td>
                            <td class="input__container override-table-input min-input" style="width:120px;">
                              @if (!isEditingWeekShares(row)) {
                                <span>{{ week_shares.sharesMidroll | percent: '1.0-3' }}</span>
                              } @else {
                                @if (row.ageId) {
                                  <input
                                    name="row-{{ index }}-shares-{{ innerIndex }}-sharesMidroll-{{ row.ageId }}"
                                    [(ngModel)]="
                                      estimates.shares[row.productFormatId][week_shares.week][row.genderId]
                                        .ages[row.ageId].shares['midroll']
                                    "
                                    wooPercentFormatter
                                    [wooMinValidator]="0"
                                    [wooMaxValidator]="1"
                                    [required]="
                                      includedProductFormatSlotTypes[row.productFormatId].midroll
                                    "
                                    [disabled]="
                                      !includedProductFormatSlotTypes[row.productFormatId].midroll
                                    "
                                  />
                                } @else {
                                  <input
                                    name="row-{{ index }}-shares-{{ innerIndex }}-sharesMidroll"
                                    [(ngModel)]="
                                      estimates.shares[row.productFormatId][week_shares.week][row.genderId]
                                        .shares['midroll']
                                    "
                                    wooPercentFormatter
                                    [wooMinValidator]="0"
                                    [wooMaxValidator]="1"
                                    [required]="
                                      includedProductFormatSlotTypes[row.productFormatId].midroll
                                    "
                                    [disabled]="
                                      !includedProductFormatSlotTypes[row.productFormatId].midroll
                                    "
                                  />
                                }
                              }
                            </td>
                            <td class="input__container override-table-input min-input" style="width:120px;">
                              @if (!isEditingWeekShares(row)) {
                                <span>{{ week_shares.sharesPostroll | percent: '1.0-3' }}</span>
                              } @else {
                                @if (row.ageId) {
                                  <input
                                    name="row-{{ index }}-shares-{{ innerIndex }}-sharesPostroll-{{ row.ageId }}"
                                    [(ngModel)]="
                                      estimates.shares[row.productFormatId][week_shares.week][row.genderId]
                                        .ages[row.ageId].shares['postroll']
                                    "
                                    wooPercentFormatter
                                    [wooMinValidator]="0"
                                    [wooMaxValidator]="1"
                                    [required]="
                                      includedProductFormatSlotTypes[row.productFormatId].postroll
                                    "
                                    [disabled]="
                                      !includedProductFormatSlotTypes[row.productFormatId].postroll
                                    "
                                  />
                                } @else {
                                  <input
                                    name="row-{{ index }}-shares-{{ innerIndex }}-sharesPostroll"
                                    [(ngModel)]="
                                      estimates.shares[row.productFormatId][week_shares.week][row.genderId]
                                        .shares['postroll']
                                    "
                                    wooPercentFormatter
                                    [wooMinValidator]="0"
                                    [wooMaxValidator]="1"
                                    [required]="
                                      includedProductFormatSlotTypes[row.productFormatId].postroll
                                    "
                                    [disabled]="
                                      !includedProductFormatSlotTypes[row.productFormatId].postroll
                                    "
                                  />
                                }
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                    @if(isEditingWeekShares(row)) {
                      <div class="two-button-container">
                        <button class="button primary" [disabled]="false" (click)="saveTargetGroups(row.productFormatId)">Spara</button>
                        <button class="link" (click)="cancelEditingWeeks(row)">Avbryt redigering</button>
                      </div>
                    }
                  </div>
                  <div>
                    @if(!isEditingWeekShares(row)) {
                      <button  (click)="setEditingDetails(row)" class="button float--left">
                        <span class="icon-edit icon__semi-medium"></span>
                        Redigera veckoestimat
                      </button>
                    } @else {
                      <button class="button primary" [disabled]="false" (click)="saveTargetGroups(row.productFormatId)">Spara</button>
                      <button class="link" (click)="cancelEditingWeeks(row)">Avbryt redigering</button>
                    }
                  </div>
                </div>
              </th>
            </tr>

          }
        }
      </tbody>
    }
  </table>

  <dot-loader [visibility]="show.loading" [large]="true"></dot-loader>

  @if (show.isEditingWithdrawalLimit) {
    <div class="margin-top--2x">
      <button
        class="button primary"
        (click)="saveTargetGroups()"
        [disabled]="targetGroupsForm.invalid"
      >
        Spara
      </button>
      <button class="link" (click)="cancelEditingWithdrawalLimits()">
        Avbryt redigering
      </button>
    </div>
  }
</div>
